export default __webpack_public_path__ + "static/capacitacion-realidad-virtual-p-bd45a16e9a4b8774c14698da33169dba.jpg";